import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";
import RunReport from "@/pages/RunReport";
import DayReplay from "@/components/DayReplay";
import { ReplayCompare } from "@/components/ReplayCompare";

export default function RunDetail() {
  const { id } = useParams();
  const [run, setRun] = useState(null);
  useEffect(() => { api.get(`/runs/${id}`).then((r) => setRun(r.data)); }, [id]);
  if (!run) return <div className="label-xs p-6">Loading…</div>;
  const liveDay = run.type === "live" && {
    ...run, charts: Object.fromEntries((run.stocks || []).map((s) => [s.sym, s.candles || []])),
  };
  return (
    <div className="space-y-3" data-testid="run-detail">
      <Link to="/history" className="text-xs text-slate-400 hover:text-slate-100 flex items-center gap-1" data-testid="back-to-history"><ArrowLeft size={12} />History</Link>
      <h1 className="text-xl font-semibold text-slate-100">{run.type === "backtest" ? "Backtest" : `${run.mode} run · ${run.date}`}</h1>
      {run.type === "live" && run.source === "kite" && <ReplayCompare run={run} />}
      {run.type === "backtest" ? <RunReport run={run} /> : <DayReplay day={liveDay} />}
    </div>
  );
}
